export const FETCH_CENTRE_DATA = 'FETCH_CENTRE_DATA'
export const FETCH_CENTRE_DATA_SUCCESS = 'FETCH_CENTRE_DATA_SUCCESS'

export const UPDATE_SPACE_DATA = 'UPDATE_SPACE_DATA'
export const UPDATE_SPACE_DATA_SUCCESS = 'UPDATE_SPACE_DATA_SUCCESS'
